<ng-container>
  @if (user(); as currentUser) {
    <div (mouseover)="isHovered = true" (mouseout)="isHovered = false">
      @if (currentUser.avatar?.iconRelativePath) {
        <img
          [class.mat-elevation-z2]="!isHovered"
          [class.mat-elevation-z4]="isHovered"
          [attr.width]="size()"
          [attr.height]="size()"
          [src]="currentUser.avatar?.iconRelativePath | webResourceUri | async" />
      } @else {
        <div
          class="user-acronym"
          [class.mat-elevation-z2]="!isHovered"
          [class.mat-elevation-z4]="isHovered"
          [style.width.px]="size()"
          [style.height.px]="size()"
          [style.font-size.px]="size() / 2.5"
          [style.background-color]="getUserColor()">
          {{ getUsernameAcronym() }}
        </div>
      }
    </div>
  }
</ng-container>
